$(function () {

  $('a[href^="#"]').on('click', function(e) {
    if (this.hash !== '' && !$(this).data("toggle")) {
      e.preventDefault();
      const $navbarHeight = $('.Navigation').outerHeight(true);
      const hash = this.hash;
      $('html, body')
        .animate({
          scrollTop: $(hash)
            .offset().top - $navbarHeight
        }, 200);
    }
  });
});